import { useCallback, useContext, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { createAutoTailoringUrlParams, selectors } from 'builder/modules/resumeEditor'
import { useTypedSelector } from 'builder/hooks/useTypedSelector'
import { useTailoredDesignation } from 'builder/hooks/useTailoredDesignation'
import { FetchStatuses } from 'builder/modules/constants'
import { selectors as userSelectors } from 'builder/modules/user'
import { SnackBarContext, SnackBarTypes } from 'builder/components/SnackBarV2'
import { useI18n } from 'builder/hooks/useI18n'

export const useTailoredResumeEdit = () => {
  const currentResume = useTypedSelector(selectors.resume)
  const originalResume = useTypedSelector(selectors.originalResume)
  const approveAutoTailoredResumeStatus = useTypedSelector(
    selectors.approveAutoTailoredResumeStatus,
  )
  const {
    averageScore: newScore,
    recommendedJobTitle,
    employerName,
  } = useTypedSelector(selectors.jobPostingAPIData)
  const oldScore = currentResume?.originalResumeAvgScore || 0
  const [isEditActive, setIsEditActive] = useState(false)
  const tailoredDesignation = useTailoredDesignation(recommendedJobTitle, employerName)
  const isApproving = approveAutoTailoredResumeStatus === FetchStatuses.loading
  const { mode, jobCardId } = useTypedSelector(selectors.autoTailoringFromPublicJobBoard)
  const user = useTypedSelector(userSelectors.userData)
  const navigate = useNavigate()
  const snackbarContext = useContext(SnackBarContext)
  const { i18n } = useI18n()

  const toggleEditContainer = useCallback(() => {
    setIsEditActive(!isEditActive)
  }, [isEditActive])

  const getJobTrackingPath = useCallback(() => {
    const successSearchParams = createAutoTailoringUrlParams({
      mode,
      jobCardId: currentResume?.jobCardId || jobCardId,
      showResumeTailoredBanner: true,
    })

    return `/job-tracking?${successSearchParams.toString()}`
  }, [jobCardId, mode, currentResume?.jobCardId])

  const handleRedirect = useCallback(() => {
    if (user?.hasPremiumFeatures) {
      navigate(getJobTrackingPath())
      return
    }

    navigate(`/resumes/${currentResume?.id}/edit`)

    snackbarContext.openSnackBar({
      text: i18n.t('builder.auto_tailoring.after_auto_tailoring_from_job_board_snackbar'),
      type: SnackBarTypes.success,
      isDismissible: true,
    })
  }, [navigate, currentResume, getJobTrackingPath, user?.hasPremiumFeatures, snackbarContext, i18n])

  return {
    oldScore,
    newScore,
    tailoredDesignation,
    toggleEditContainer,
    isEditActive,
    currentResume,
    originalResume,
    isApproving,
    handleRedirect,
    getJobTrackingPath,
    setIsEditActive,
  }
}
